import type { LocalEquipmentModel } from '../models/ultrasonic.models';

// TODO: Replace with real API data
export const DEFAULT_EQUIPMENT: LocalEquipmentModel[] = [
  {
    id: '4222124650711198',
    name: 'SWE ScanMaster LS200',
    schaefflerId: 12357738,
    plantId: '8725724278068983',
    calibrationIo: false,
    lastCalibration: new Date(1778680508471).toISOString(),
    remainingTime: '-7917',
    defaultTestInstructionId: '43065671436845772',
    testInstructionNames: ['S 231202-5', 'SWE LS200 - S 231202-5 (3 Volumes)', 'SWE LS200 - S 231202-5 (2 Volumes)', 'SWE LS200 - S 231202-5 (2 Volumes) - V2'],
  },
  {
    id: '4222124650737151',
    name: 'ISB Scanmaster LS200',
    schaefflerId: 12332937,
    plantId: '8725724278081779',
    calibrationIo: false,
    lastCalibration: new Date(1755593118373).toISOString(),
    remainingTime: '-392707',
    defaultTestInstructionId: '43065671436847056',
    testInstructionNames: ['ISB LS200 - S 231202-5 (2 Volumes)', 'ISB LS200 - S 231202-5 (3 Volumes)', 'IN ISB 20192-D', 'IN ISB 20192-G', 'IN ISB 20456-C'],
  },
  {
    id: '4222124650737289',
    name: 'ISB Scanmaster LS 500',
    schaefflerId: 12318020,
    plantId: '8725724278081779',
    calibrationIo: false,
    lastCalibration: new Date(1776849802241).toISOString(),
    remainingTime: '-38429',
    defaultTestInstructionId: '43065671436848109',
    testInstructionNames: ['ISB LS500 - S 231202-5 (2 Volumes)', 'ISB LS500 - S 231202-5 (3 Volumes)'],
  },
  {
    id: '4222124650737751',
    name: 'ISB Scanmaster DS200-XL',
    schaefflerId: 12733782,
    plantId: '8725724278081779',
    calibrationIo: false,
    lastCalibration: new Date(1755593458441).toISOString(),
    remainingTime: '-392702',
    defaultTestInstructionId: '43065671436847522',
    testInstructionNames: ['ISB DS200-XL - S 231202-5 (2 Volumes)', 'ISB DS200-XL - S 231202-5 (3 Volumes)'],
  },
  {
    id: '4222124650749595',
    name: '12563114',
    schaefflerId: 12563114,
    plantId: '',
    calibrationIo: false,
    lastCalibration: new Date(1577836800000).toISOString(),
    remainingTime: '-3355313',
    testInstructionNames: [],
  },
];
